import { Injectable } from '@angular/core';
import { HttpClient,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs';
import { IPagedResults } from '../../../services/mocks/mock.interfaces';
import { LoggerService } from '../../../shared/services/logger.service';
import { environment } from '../../../../environments/environment';
import { Authority } from '../..//../models/authority.model';
import { Subject } from '../..//../models/subject.model';
import { FeeType } from 'src/app/models/fee-type.model';
import { FeeStudent } from 'src/app/models/fee-student.model';
import { FeeMaster } from 'src/app/models/fee-master.model';

@Injectable({
  providedIn: 'root'
})
export class FeeService {

  constructor(private http: HttpClient,
              private logger: LoggerService) {
  }

  getFeeTypeById(id: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/fee/type/id/'+id);
  }
  addFeeType(feeType: FeeType): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/fee/type',feeType);
  }
  updateFeeType(feeType: FeeType): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/fee/type/update',feeType);
  }
  getFeeTypeListPage(page: number, size: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/fee/type?page='+page+'&size='+size);
  }
  getFeeTypeList(): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/fee/type/all');
  }
  addFeeMaster(feeMaster: any,courseId: number, feeGroup: string): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/fee/master?courseId='+courseId+'&feeGroup='+feeGroup,feeMaster);
  }
  deleteFeeMaster(feeMaster: FeeMaster): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/fee/master/delete',feeMaster);
  }
  getFeeMasterList(): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/fee/master/all');
  }

  getFeeMasterById(feeMasterId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/fee/master/id/'+feeMasterId);
  }
  getFeeMasterByCourse(courseId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/fee/master/course/'+courseId);
  }
  checkFeeMaster(feeTypeCode: string): Observable<number> {  
    return this.http.get<any>(environment.apiBase+'/fee/master/check/'+feeTypeCode);
  }
  compareFeeMaster(studentUName: string): Observable<any> {
    return this.http.get<any>(environment.apiBase+'/fee/master/compare/'+studentUName);
  }

  getFeeListPage(page: number, size: number, studentUName: string, activeSession: string): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/fee/details?page='+page+'&size='+size+'&studentUName='+studentUName+'&activeSession='+activeSession);
  }
  getFeeById(feeId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/fee/getById/'+feeId);
  }
  updateFee(feeStudent: FeeStudent){
    return this.http.post<any>(environment.apiBase+'/fee/update',feeStudent);
  }
  getPaymentHistoryByFeeId(feeId: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/fee/paymentHistory/'+feeId);
  }
  renderReceiptPdf(paymentHistId: number): any {  
    let params = {location: "report.pdf"};
    return this.http.get(environment.apiBase+'/fee/payment/receipt/'+paymentHistId, {responseType : 'blob'});   
  }
  generateReceipt(paymentHistId: number):Observable<any> {   
    return this.http.get(environment.apiBase+'/fee/payment/receipt/generate/'+paymentHistId);   
  }
  updateDiscount(feeStudent: FeeStudent): Observable<any> {
    return this.http.put<any>(environment.apiBase+'/fee/discount',feeStudent);
  }

  updateFeeMaster(feeMaster: FeeMaster): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/fee/master/update',feeMaster);
  }


  /******************************************************************************************/
  getSubjectListPage(page: number, size: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/subjects?page='+page+'&size='+size);
  }
  getSubjectList(): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/subjects/all');
  }
  addSubject(subject: Subject): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/subjects',subject);
  }

  getAuthorityListPage(page: number, size: number): Observable<any> {  
    return this.http.get<any>(environment.authBase+'/api/roles?page='+page+'&size='+size);
  }
  getAuthorityList(): Observable<any> {  
    return this.http.get<any>(environment.authBase+'/api/roles/all');
  }
  getAuthorityById(authorityId: number): Observable<Authority> {  
    return this.http.get<any>(environment.authBase+'/api/roles/'+authorityId);
  }
  addAuthority(authority: Authority): Observable<any> {
    return this.http.post<any>(environment.authBase+'/api/roles',authority);
  }  
  updateAuthority(authority: Authority): Observable<any> {
    return this.http.put<any>(environment.authBase+'/api/roles/update',authority);
  }
  deleteAuthorities(authorityList: Authority[]): Observable<any> { 
    console.log('deleteAuthorities>>> ',JSON.stringify(authorityList))
    return this.http.post<any>(environment.authBase+'/api/roles/delete',authorityList);
  }
}
